import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Malwarebytes extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M10.6753332,21.3299792 L10.6753332,21.3299792 C10.9236024,21.3299792 11.0063532,21.2472284 11.0063532,21.0817184 C11.0063532,20.9162084 10.9236024,20.8334576 10.7580924,20.8334576 L10.6753332,20.8334576 L10.5098232,20.8334576 C7.36515841,20.1714176 4.96527601,17.3577632 4.96527601,13.9648292 C4.96527601,12.5579984 5.37904681,11.2339268 6.12383761,10.075364 C6.20658841,9.90985401 6.45485761,9.82710321 6.62036761,9.99260601 L11.6683932,15.1233908 C11.7511452,15.2061416 11.833896,15.2061416 11.9166552,15.2061416 C11.999406,15.2061416 12.0821652,15.2061416 12.164916,15.1233908 L17.2957008,10.075364 C17.4612108,9.90985401 17.6267208,9.90985401 17.7922224,10.158116 C18.5370144,11.2339268 18.9507924,12.6407576 18.9507924,14.04758 C18.9507924,15.8681816 18.2887524,17.4405152 17.2129416,18.681836 L17.1301908,18.7645868 L17.1301908,18.847346 C17.1301908,19.012856 17.2129416,19.0956068 17.3784516,19.0956068 C17.3784516,19.0956068 17.3784516,19.0956068 17.4612108,19.0956068 C17.4612108,19.0956068 17.5439616,19.0956068 17.5439616,19.012856 C24.24708,16.1164424 23.9988192,9.49608321 23.9988192,9.49608321 C23.9988192,5.6066192 22.1782176,2.213684 19.3645632,0.0620623945 C19.2818052,-0.0206884056 19.0335444,-0.0206884056 18.9507924,0.0620623945 L12.164916,6.7651808 C12.0821652,6.84794 11.833896,6.84794 11.7511452,6.7651808 L5.04802681,0.0620623945 C4.96527601,-0.0206884056 4.79976601,-0.0206884056 4.63425601,0.0620623945 C1.8206016,2.213684 -3.19744231e-14,5.68937 -3.19744231e-14,9.49608321 L-3.19744231e-14,9.49608321 C-3.19744231e-14,15.6199208 4.63425601,20.7506984 10.6753332,21.3299792" />
      </svg>
    );
  }
}

export default Malwarebytes;
